import { handleImport } from '../../utils/utils';

export const utilInformationLinks = [
  {
    path: `/informacionutil/nosotros`,
    title: 'Sobre Nosotros',
    private: false,
  },
  {
    path: `/informacionutil/mapa-de-sucursales`,
    title: 'Sucursales',
    private: false,
  },
  {
    path: `/informacionutil/novedades`,
    title: 'Info Swiss',
    private: false,
  },
  {
    path: `/informacionutil/aequalis`,
    title: 'Revista Æqualis',
    private: false,
  },
  {
    path: `/informacionutil/ser-prestador`,
    title: 'Quiero ser Prestador',
    private: false,
  },
  {
    path: `/informacionutil/documentacion-para-autorizaciones`,
    title: 'Documentación para autorizaciones',
    private: true,
  },
  {
    path: `/informacionutil/practicas`,
    title: 'Guias de Practicas Clínicas',
    private: true,
  },
  {
    path: `/informacionutil/fraude`,
    title: 'Linea de denuncias',
    private: false,
  },
  {
    path: `/informacionutil/datos-impositivos`,
    title: 'Datos Impositivos',
    private: false,
  },
  {
    path: handleImport('CODIGO_DE_ETICA.pdf'),
    title: 'Código de Ética',
    isExternalLink: true,
    private: false,
  },
  {
    path: handleImport('Codigo_de_Gobierno_Corporativo_Swiss_Medical_SA.pdf'),
    title: 'Código de Gobierno Corporativo Swiss Medical SA',
    isExternalLink: true,
    private: false,
  },
  {
    path: `/informacionutil/documentos`,
    title: 'Documentos y Formularios',
    private: false,
  },
];

export const medicalCenterLinks = [
  {
    path: 'https://www.swissmedical.com.ar/prepagaclientes/clinicas',
    title: 'Nuestras Clinicas',
    isExternalLink: true,
  },
  {
    path: 'https://www.swissmedicalcenter.com.ar/',
    title: 'Swiss Medical Center',
    isExternalLink: true,
  },
  {
    path: 'https://www.swissmedicalcenter.com.ar/',
    title: 'Centros Odontológicos',
    isExternalLink: true,
  },
  {
    path: `/centrosmedicos/vacunatorios`,
    title: 'Vacunatorios',
  },
];

export const preventionLinks = [
  {
    path: `/prevencion/objetivos`,
    title: 'Objetivos y alcance',
  },
  {
    path: `/prevencion/ciclo-actividades`,
    title: 'Ciclo de Actividades',
  },
  {
    path: `/prevencion/embarazo-saludable`,
    title: 'Embarazo Saludable',
  },
  {
    path: `/prevencion/cesacion-tabaquica`,
    title: 'Cesacion Tabaquica',
  },
  {
    path: `/prevencion/diabetes`,
    title: 'Diabetes Tipo 2',
  },
  {
    path: `/prevencion/re-educacion-alimentaria`,
    title: 'Re Educacion Alimentaria',
  },
  {
    path: `/prevencion/insuficiencia_cardiaca`,
    title: 'Insuficiencia Cardiaca',
  },
  {
    path: `/prevencion/epoc`,
    title: 'EPOC',
  },
  {
    path: `/prevencion/guias-prevencion`,
    title: 'Guias de Prevencion',
  },
];

export const instructionsLinks = [
  {
    path: handleImport('CAPWEB-Contrataciones.pdf'),
    title: '- Contratación',
    hasInitalSpace: true,
    isExternalLink: true,
  },
  {
    path: handleImport('CAPWEB-Actualizacion-de-datos.pdf'),
    title: '- ADP',
    hasInitalSpace: true,
    isExternalLink: true,
  },
  {
    path: handleImport('CAPWEB-Autorizaciones.pdf'),
    title: '- Autorizaciones',
    hasInitalSpace: true,
    isExternalLink: true,
  },
  {
    path: handleImport('CAPWEB-Liquidaciones.pdf'),
    title: '- Liquidaciones',
    hasInitalSpace: true,
    isExternalLink: true,
  },
  {
    path: handleImport('Cargar-Factura-Prest-Direct-Honorarios.pdf'),
    title: 'Cargar Factura Prest. Direct. Honorarios',
    isExternalLink: true,
  },
  {
    path: handleImport('Instructivo_Conectividad_Efectores_Colegiados_e_Instituciones.pdf'),
    title: 'Instructivo para Efectores Colegiados e Instituciones',
    isExternalLink: true,
  },
  {
    path: handleImport('Cómo_eliminar_Cookies_e_Historial.pdf'),
    title: 'Cómo eliminar Cookies e Historial',
    isExternalLink: true,
  },
  {
    path: handleImport('Conectividad.pdf'),
    title: 'CONECTIVIDAD como transaccionar y bajar reporte',
    isExternalLink: true,
  },
  {
    path: handleImport('Descriptivo-Rechazos-Conectividad.pdf'),
    title: 'Rechazos conectividad',
    isExternalLink: true,
  },
  {
    path: handleImport('Gestionar-usuario.pdf'),
    title: 'Gestionar usuario',
    isExternalLink: true,
  },
  {
    path: handleImport('Validar-Afiliado.pdf'),
    title: 'Validar afiliado',
    isExternalLink: true,
  },
  {
    path: handleImport('Censos.pdf'),
    title: 'Censos',
    isExternalLink: true,
  },
  {
    path: handleImport('como-registrarse.pdf'),
    title: 'Cómo registrarse',
    isExternalLink: true,
  },
  {
    path: `/informacionutil/planillas-presentaciones`,
    title: 'Planillas para presentaciones',
    private: true,
  },
];

export const contactLinks = [
  {
    path: `/contacto/telefonos`,
    title: 'Teléfonos útiles',
  },
];
